/**
 * Pending page-level share restore payloads (consumed when target page mounts).
 */
const pendingByPage = new Map<string, Record<string, unknown>>();

export function setPendingPageShareRestore(pageKey: string, payload: Record<string, unknown>): void {
  pendingByPage.set(pageKey, payload);
}

export function peekPendingPageShareRestore(pageKey: string): boolean {
  return pendingByPage.has(pageKey);
}

export function consumePendingPageShareRestore(pageKey: string): Record<string, unknown> | null {
  const payload = pendingByPage.get(pageKey);
  if (payload == null) {
    return null;
  }
  pendingByPage.delete(pageKey);
  return payload;
}

/** Active page mirrors (while page is mounted). */
const mirrorByPage = new Map<string, Record<string, unknown>>();

export function setPageShareMirror(pageKey: string, state: Record<string, unknown> | null): void {
  if (state == null) {
    mirrorByPage.delete(pageKey);
    return;
  }
  mirrorByPage.set(pageKey, state);
}

export function getPageShareMirror(pageKey: string): Record<string, unknown> | null {
  return mirrorByPage.get(pageKey) ?? null;
}

export function clearPageShareMirror(pageKey: string): void {
  mirrorByPage.delete(pageKey);
}
